(function () {
  function bind() {
    document.removeEventListener('click', onClick, true);
    document.addEventListener('click', onClick, true);
  }

  function onClick(e) {
    // READ MORE BUTTON
    const readMoreBtn = e.target.closest('.read-more-btn');
    if (readMoreBtn) {
      e.preventDefault();
      scrollToNextSection(readMoreBtn, '.section.section--padding');
      return;
    }

    // SEE MORE BUTTON by class
    const seeMoreBtn = e.target.closest('.scroll-to-image-text-btn');
    if (seeMoreBtn) {
      e.preventDefault();
      const target = document.querySelector('#shopify-section-template--24958162829608__image-with-text-1');
      if (target) scrollWithOffset(target);
      return;
    }

    // ANY anchor link starting with #
    const anchorLink = e.target.closest('a[href^="#"]');
    if (anchorLink && anchorLink.getAttribute('href').length > 1) {
      e.preventDefault();
      const id = anchorLink.getAttribute('href');
      const target = document.querySelector(id);
      if (target) scrollWithOffset(target);
    }
  }

  function scrollToNextSection(startEl, selector) {
    const sections = Array.from(document.querySelectorAll(selector));
    if (!sections.length) return;
    const btnTop = startEl.getBoundingClientRect().top + window.scrollY;
    let target = sections.find(el => (el.getBoundingClientRect().top + window.scrollY) > btnTop);
    if (!target) target = sections[sections.length - 1];
    scrollWithOffset(target);
  }

  function scrollWithOffset(target) {
    const header = document.querySelector('[data-sticky-header], .shopify-section-header, header.site-header');
    const offset = header ? header.offsetHeight + 10 : 0;
    const y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
